const mediaType = {
    IMAGE: 1,
    PDF: 2,
    VIDEO: 3,
    AUDIO: 4,
};
module.exports = mediaType;